<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <h4 class="pull-right">Изменить категорию</h4>
          </header>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form autcomplete="off" @submit.prevent="categoryUpdate()">
                  <div class="form-group">
                    <label>titleRus</label>
                    <input type="text" class="form-control" v-model="category.title" />
                  </div>
                  <!-- <div class="form-group">
                    <label>titleUzl</label>
                    <input type="text" class="form-control" v-model="category.titleUzl" />
                  </div>
                  <div class="form-group">
                    <label>titleUzk</label>
                    <input type="text" class="form-control" v-model="category.titleUzk" />
                  </div>
                  <div class="form-group">
                    <label>version</label>
                    <input type="text" class="form-control" v-model="category.version" />
                  </div> -->
                  <div class="form-group">
                    <label>Код</label>
                    <input type="text" class="form-control" v-model="category.code" />
                  </div>
                  <div class="form-group">
                    <label>Категория тегишлилиги</label>
                    <select class="form-control" v-model="category.parent_id">
                      <option value="0">Основная Категория</option>
                      <option
                        :value="cat.id"
                        v-for="cat in categories"
                        :key="cat.id"
                        :selected="cat.id == category.id"
                        :disabled="cat.id == category.id"
                      >{{ cat.title }}</option>
                    </select>
                  </div>
                  <button type="submit" class="btn btn-primary">Изменить</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { EDIT, FILE, GET, POST } from "../../shared/api";
export default {
  data() {
    return {
      category: {},
      categories: []
    };
  },
  methods: {
    getCategory(id) {
      EDIT(id, "/category/", this, false).then(response => {
        this.category = response;
      });
    },
    getCategories() {
      GET([], "/category", this, false).then(response => {
        this.categories = response;
      });
    },
    categoryUpdate() {
      POST(this.category, "/categoryUpdate", this).then(response => {
        this.$router.push({ name: "category" });
      });
    }
  },
  created() {
    this.getCategory(this.$route.params.category_id);
    this.getCategories();
  }
};
</script>
